<section class="h-full flex flex-col gap-2 z-0 relative  p-2 lg:pl-0">

  <div class="flex flex-wrap xl:flex-nowrap flex-col sm:flex-row sm:justify-between sm:items-center gap-2">

    <div class="flex flex-col sm:flex-row gap-2">

      <!-- search -->
      <div class="relative">
        <input [(ngModel)]="search" (input)="onSearchInput()" type="text" placeholder="Search.."
          class="pl-8" />
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
          class="absolute left-2 top-1/2 transform -translate-y-1/2 size-5">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
        </svg>
      </div>

      <!-- Date picker -->
      <div>
        <div> 
          <input type="text" name="time" id="time" [(ngModel)]="todayDate" [owlDateTime]="date" [readOnly]="true"
            (ngModelChange)="onDateChange($event)" [owlDateTimeTrigger]="date" [selectMode]="'range'" />
          <owl-date-time [pickerType]="'calendar'" #date></owl-date-time>
        </div>
      </div>

      <!-- service areas selector -->
      <div>

        <select class="w-full sm:w-44" [(ngModel)]="selectedServiceArea" (change)="onServiceAreaChange()">
          <option value="">Select Service Area</option>
          <option *ngFor="let serviceArea of serviceAreas" value="{{serviceArea.id}}">{{ serviceArea.title | titlecase
            }}</option>
        </select>
      </div>
      <div class="min-w-48 max-w-48">
        <ng-select id="member" [notFoundText]="'No record found'" [clearable]="true" [(ngModel)]="selectedMembers"
          (scrollToEnd)="onScroll()" [searchable]="true" (search)="onSearch($event)" [searchable]="true" (clear)="onClear()"
          (close)="onClose()" (change)="onMembersChange($event)">
          <ng-option *ngIf="members && members.length > 0" value="">
            Select Member</ng-option>
          <ng-option *ngFor="let member of members" value="{{ member.id }}">
            {{member?.displayName + (member.contactNumber ? " - " + member.contactNumber : "") | titlecase }}</ng-option>
        </ng-select>
      
      </div>

      <div *ngIf="selectedStatus === 'pending'" class="min-w-48">
        <select class="" [(ngModel)]="selectedPendingStatus" (change)="onPendingStatusChange()">
          <option value="">Select Status</option>
          <option value="initiated">Initiated</option>
          <option value="cancelled">Cancelled</option>
          <option value="rejected">Rejected</option>
          <option value="re-offered">Re-Offered</option>
        </select>
      </div>

    </div>




    <div class="flex items-center gap-2">
      <div
        class="hidden md:inline-flex border border-zinc-950/10 hover:border-zinc-950/20 dark:border-white/10 dark:hover:border-white/20 gap-1 overflow-hidden rounded-md bg-white dark:bg-zinc-900 p-1">
        <!-- All -->
        <a href="javascript:void(0)" (click)="filterTrips('all')" [ngClass]="{
            'bg-zinc-950/80 dark:bg-zinc-700 text-white': selectedStatus === 'all',
            'bg-white dark:bg-zinc-900 text-zinc-700 dark:text-zinc-300 hover:bg-zinc-100 dark:hover:bg-zinc-800': selectedStatus !== 'all'
          }" class="relative inline-flex whitespace-nowrap items-center px-1 py-1.5 text-xs font-medium rounded">
          All
          <div *ngIf="selectedStatus === 'all' && filterdataList.length"
            class="ml-1 grid place-content-center text-xs px-1 bg-white dark:bg-zinc-300 text-zinc-600 dark:text-zinc-800 rounded">
               <span>{{ getPageCount() }}</span>
          </div>
        </a>
        <!-- Pending -->
        <a href="javascript:void(0)" (click)="filterTrips('pending')"
          [ngClass]="{'bg-zinc-950/80 dark:bg-zinc-700 text-white': selectedStatus === 'pending', 'bg-white dark:bg-zinc-900 text-zinc-700 dark:text-zinc-300 hover:bg-zinc-100 dark:hover:bg-zinc-800': selectedStatus !== 'pending'}"
          class="relative inline-flex whitespace-nowrap items-center px-1 py-1.5 text-xs font-medium rounded">
          Pending
          <div
            *ngIf="filterdataList.length && selectedStatus === 'pending'"
            class="ml-1 grid place-content-center text-xs px-1 bg-white dark:bg-zinc-300 text-zinc-600 dark:text-zinc-800 rounded">
               <span>{{ getPageCount() }}</span>
          </div>
        </a>
        <!-- Scheduled -->
        <a href="javascript:void(0)" (click)="filterTrips('scheduled')"
          [ngClass]="{'bg-zinc-950/80 dark:bg-zinc-700 text-white': selectedStatus === 'scheduled', 'bg-white dark:bg-zinc-900 text-zinc-700 dark:text-zinc-300 hover:bg-zinc-100 dark:hover:bg-zinc-800': selectedStatus !== 'scheduled'}"
          class="relative inline-flex whitespace-nowrap items-center px-1 py-1.5 text-xs font-medium rounded">
          Scheduled
          <div
            *ngIf="filterdataList.length && selectedStatus === 'scheduled'"
            class="ml-1 grid place-content-center text-xs px-1 bg-white dark:bg-zinc-300 text-zinc-600 dark:text-zinc-800 rounded">
               <span>{{ getPageCount() }}</span>
          </div>
        </a>
        <!-- offered -->
        <a href="javascript:void(0)" (click)="filterTrips('offered')"
          [ngClass]="{'bg-zinc-950/80 dark:bg-zinc-700 text-white': selectedStatus === 'offered', 'bg-white dark:bg-zinc-900 text-zinc-700 dark:text-zinc-300 hover:bg-zinc-100 dark:hover:bg-zinc-800': selectedStatus !== 'offered'}"
          class="relative inline-flex whitespace-nowrap items-center px-1 py-1.5 text-xs font-medium rounded">
          Offered
          <div *ngIf="filterdataList.length && filterdataList[0]?.status == 'offered' && selectedStatus === 'offered'"
            class="ml-1 grid place-content-center text-xs px-1 bg-white dark:bg-zinc-300 text-zinc-600 dark:text-zinc-800 rounded">
               <span>{{ getPageCount() }}</span>
          </div>
        </a>

        <!-- reroute -->
       
        <!-- onway -->
        <a href="javascript:void(0)" (click)="filterTrips('onway')"
          [ngClass]="{'bg-zinc-950/80 dark:bg-zinc-700 text-white': selectedStatus === 'onway', 'bg-white dark:bg-zinc-900 text-zinc-700 dark:text-zinc-300 hover:bg-zinc-100 dark:hover:bg-zinc-800': selectedStatus !== 'onway'}"
          class="relative inline-flex whitespace-nowrap items-center px-1 py-1.5 text-xs font-medium rounded">
          Onway
          <div *ngIf="filterdataList.length && filterdataList[0]?.status == 'onway' && selectedStatus === 'onway'"
            class="ml-1 grid place-content-center text-xs px-1 bg-white dark:bg-zinc-300 text-zinc-600 dark:text-zinc-800 rounded">
               <span>{{ getPageCount() }}</span>
          </div>
        </a>
        <!-- arrived -->
        <a href="javascript:void(0)" (click)="filterTrips('arrived')"
          [ngClass]="{'bg-zinc-950/80 dark:bg-zinc-700 text-white': selectedStatus === 'arrived', 'bg-white dark:bg-zinc-900 text-zinc-700 dark:text-zinc-300 hover:bg-zinc-100 dark:hover:bg-zinc-800': selectedStatus !== 'arrived'}"
          class="relative inline-flex whitespace-nowrap items-center px-1 py-1.5 text-xs font-medium rounded">
          Arrived
          <div *ngIf="filterdataList.length && filterdataList[0]?.status == 'arrived' && selectedStatus === 'arrived'"
            class="ml-1 grid place-content-center text-xs px-1 bg-white dark:bg-zinc-300 text-zinc-600 dark:text-zinc-800 rounded">
               <span>{{ getPageCount() }}</span>
          </div>
        </a>
        <!-- inProgress -->
        <a href="javascript:void(0)" (click)="filterTrips('in_progress')"
          [ngClass]="{'bg-zinc-950/80 dark:bg-zinc-700 text-white': selectedStatus === 'in_progress', 'bg-white dark:bg-zinc-900 text-zinc-700 dark:text-zinc-300 hover:bg-zinc-100 dark:hover:bg-zinc-800': selectedStatus !== 'in_progress'}"
          class="relative inline-flex whitespace-nowrap items-center px-1 py-1.5 text-xs font-medium rounded">
          In Progress
          <div
            *ngIf="filterdataList.length && filterdataList[0]?.status == 'in_progress' && selectedStatus === 'in_progress'"
            class="ml-1 grid place-content-center text-xs px-1 bg-white dark:bg-zinc-300 text-zinc-600 dark:text-zinc-800 rounded">
               <span>{{ getPageCount() }}</span>
          </div>
        </a>
        <!-- completed -->
        <a href="javascript:void(0)" (click)="filterTrips('completed')"
          [ngClass]="{'bg-zinc-950/80 dark:bg-zinc-700 text-white': selectedStatus === 'completed', 'bg-white dark:bg-zinc-900 text-zinc-700 dark:text-zinc-300 hover:bg-zinc-100 dark:hover:bg-zinc-800': selectedStatus !== 'completed'}"
          class="relative inline-flex whitespace-nowrap items-center px-1 py-1.5 text-xs font-medium rounded">
          Completed
          <div
            *ngIf="filterdataList.length && filterdataList[0]?.status == 'completed' && selectedStatus === 'completed'"
            class="ml-1 grid place-content-center text-xs px-1 bg-white dark:bg-zinc-300 text-zinc-600 dark:text-zinc-800 rounded">
               <span>{{ getPageCount() }}</span>
          </div>
        </a>
        <!-- cancelled -->
        <a href="javascript:void(0)" (click)="filterTrips('cancelled')"
          [ngClass]="{'bg-zinc-950/80 dark:bg-zinc-700 text-white': selectedStatus === 'cancelled', 'bg-white dark:bg-zinc-900 text-zinc-700 dark:text-zinc-300 hover:bg-zinc-100 dark:hover:bg-zinc-800': selectedStatus !== 'cancelled'}"
          class="relative inline-flex whitespace-nowrap items-center px-1 py-1.5 text-xs font-medium rounded">
          Cancelled
          <div *ngIf="filterdataList.length && filterdataList[0]?.status == 'cancelled' && selectedStatus === 'cancelled'"
            class="ml-1 grid place-content-center text-xs px-1 bg-white dark:bg-zinc-300 text-zinc-600 dark:text-zinc-800 rounded">
               <span>{{ getPageCount() }}</span>
          </div>
        </a>
      </div>

      <div class="relative inline-block text-left" (outsideClick)="closeFilterDropDown($event)" outside-click>
        <div>
          <button [appToolTip]="'Filters'" type="button" (click)="toggleDropdown($event)" class="btn btn-secondary" id="menu-button"
            aria-expanded="true" aria-haspopup="true">

            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
              stroke="currentColor" class="size-5">
              <path stroke-linecap="round" stroke-linejoin="round"
                d="M10.5 6h9.75M10.5 6a1.5 1.5 0 1 1-3 0m3 0a1.5 1.5 0 1 0-3 0M3.75 6H7.5m3 12h9.75m-9.75 0a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m-3.75 0H7.5m9-6h3.75m-3.75 0a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m-9.75 0h9.75" />
            </svg>
             <span 
             *ngIf="(selectedSpaceType && selectedSpaceType.length > 0)"
              class="flex absolute h-3 w-3 -top-1 -right-1">
              <span class="animate-ping absolute inline-flex h-full w-full rounded-full opacity-75 bg-red-500"></span>
              <span class="relative inline-flex rounded-full h-3 w-3 bg-red-500"></span>
            </span>
          </button>
        </div>
        <div *ngIf="isDropdownOpen"
          class="absolute right-0 z-50 mt-2 w-72 origin-top-right rounded-md bg-white dark:bg-zinc-900 shadow-lg border border-zinc-950/10 hover:border-zinc-950/20 dark:border-white/10 dark:hover:border-white/20 focus:outline-none"
          role="menu" aria-orientation="vertical" aria-labelledby="menu-button" tabindex="-1">
          <div class="p-3 grid grid-cols-2 gap-2" role="none">
            <!-- Active: "bg-gray-100 text-gray-900 outline-none", Not Active: "text-gray-700" -->
            <!-- assign Button -->
            <div class="sm:col-span-2" role="menuitem" tabindex="-1" id="menu-item-0">
              <label for="Space type" class="text-xs font-bold">Space Type</label>
              <select class="" [(ngModel)]="selectedSpaceType" (change)="onSpaceTypeChange()">
                <option value="">Select Space Type</option>
                <option *ngFor="let spaceType of filteredSpacetypes" value="{{spaceType.id}}">{{ spaceType.title | uppercase }}
                </option>
              </select>
            </div>
            <hr *ngIf="selectedTrips && selectedTrips.length" class="sm:col-span-2 dark:border-white/10">
            <div class="sm:col-span-2 mt-2" role="menuitem" tabindex="-1" id="menu-item-1">
              <div *ngIf="selectedTrips && selectedTrips.length" class="p-1 grid grid-cols-1 gap-1">
                <button (click)="tripDetailFile()" class="btn btn-secondary text-xs w-full">
                  Trips Report
                </button>
                <ng-container *ngIf="selectedStatus">
                  <button *ngIf="tripStatus === 'scheduled' || tripStatus === 'offered'"
                    (click)="openMultiCancelModal()" class="btn btn-danger text-xs w-full">
                    Cancel
                  </button>
                  <button *ngIf="selectedStatus === 'pending' && isPendingTripEligibleForReoffer()" (click)="reOfferTrips()" class="btn btn-primary text-xs w-full">
                    Re-Offer
                  </button>
                  <button *ngIf="selectedStatus === 'pending' && isPendingTripEligibleForCancel()" (click)="openPendingCancelModal()" class="btn btn-danger text-xs w-full">
                    Cancel
                  </button>
                </ng-container>
              </div>
            </div>

          </div>
        </div>
      </div>

    </div>
  </div>

  <div *ngIf="selectedTrips && selectedTrips.length " class="w-36 rounded-xl bg-gray-200 dark:bg-zinc-950 px-2 py-2">
    <dl class="flex items-center">
      <dt class="grid place-content-center flex-shrink-0 rounded-lg bg-main-base">
        <svg class="h-8 w-8 text-main-primary" fill="currentColor" viewBox="0 0 24 24" version="1.1"
          xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <g stroke="none" stroke-width="1" fill="currentColor" fill-rule="evenodd">
            <g fill="currentColor" fill-rule="nonzero">
              <path
                d="M20.4961766,5.62668182 C21.3720675,5.93447702 22,6.76890777 22,7.75 L22,17.75 C22,20.0972102 20.0972102,22 17.75,22 L7.75,22 C6.76890777,22 5.93447702,21.3720675 5.62668182,20.4961766 L7.72396188,20.4995565 L17.75,20.5 C19.2687831,20.5 20.5,19.2687831 20.5,17.75 L20.5,7.75 L20.4960194,7.69901943 L20.4961766,5.62668182 Z M17.246813,2 C18.4894537,2 19.496813,3.00735931 19.496813,4.25 L19.496813,17.246813 C19.496813,18.4894537 18.4894537,19.496813 17.246813,19.496813 L4.25,19.496813 C3.00735931,19.496813 2,18.4894537 2,17.246813 L2,4.25 C2,3.00735931 3.00735931,2 4.25,2 L17.246813,2 Z M13.4696699,7.46966991 L9.58114564,11.3581942 L8.6,10.05 C8.35147186,9.71862915 7.88137085,9.65147186 7.55,9.9 C7.21862915,10.1485281 7.15147186,10.6186292 7.4,10.95 L8.9,12.95 C9.17384721,13.3151296 9.70759806,13.3530621 10.0303301,13.0303301 L14.5303301,8.53033009 C14.8232233,8.23743687 14.8232233,7.76256313 14.5303301,7.46966991 C14.2374369,7.1767767 13.7625631,7.1767767 13.4696699,7.46966991 Z">
              </path>
            </g>
          </g>
        </svg>
      </dt>
      <dd class="w-full ml-4 truncate text-right">
        <div class="text-xs text-main-light flex-1 "> Selected Trips </div>
        <div class="text-sm font-bold text-main-secondary flex-1 truncate">{{selectedTrips.length}}</div>
      </dd>
    </dl>
  </div>

  <div
    class="h-full overflow-hidden p-2 flex flex-col rounded-lg bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10">
    <div class="h-full w-full overflow-hidden rounded-md ring-1 ring-zinc-950/10 dark:ring-white/10">
      <div class="flow-root h-full overflow-y-auto">
        <div class="-my-2">
          <div class="inline-block min-w-full py-2 align-middle">
            <table class="min-w-full table-auto">
              <thead>
                <tr>
                  <th
                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    #</th>

                  <th
                    *ngIf="(tripStatus !== 'onway' && tripStatus !== 'arrived' && tripStatus !== 'in_progress') && permissionService.hasPermission([userPermission.MANAGE_TRIP])"
                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    <input type="checkbox"
                      [checked]="selectedTrips.length && selectedTrips.length === filterdataList.length"
                      (change)="onSelectAllTrips($event)" />
                  </th>

                  <th
                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    Action</th>
                  <th
                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    Stamps</th>
                  <th
                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    Service Area</th>
                  <th
                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    Reference ID
                  </th>
                  <th
                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    Association
                  </th>
                  <th *ngIf="selectedStatus !== 'scheduled' "
                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    Company</th>
                  <th *ngIf="selectedStatus !== 'scheduled' "
                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    Driver</th>
                  <th
                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    Member</th>
                  <th
                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    Contact No.</th>

                  <th
                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    Pickup Time
                  </th>
                  <th
                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    Dropoff Time
                  </th>
                  <th
                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    Pickup Address</th>
                  <th
                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    Dropoff Address</th>
                  <th
                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    Miles</th>
                  <th
                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    Special Fare</th>
                  <th
                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    Space Type</th>
                  <th
                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    Appointment Type</th>
                  <th
                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    SO 
                  </th>
                  <th
                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    Created At </th>
                  <th *ngIf="selectedStatus !== 'pending'"
                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    Status </th>
                  <th *ngIf="selectedStatus === 'all' || selectedStatus === 'pending'"
                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    {{selectedStatus === 'all' ? 'Pending Status' : 'Status'}} 
                  </th>
                    <th *ngIf="selectedStatus === 'all' || selectedStatus === 'pending' || selectedStatus === 'reroute' || selectedStatus === 'cancelled'"
                      class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                      {{ selectedStatus === 'reroute' ? 'Change Reason' : 'Cancel Reason' }}
                    </th>
                  <th
                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    General Notes</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  *ngFor="let trip of filterdataList  | paginate: { itemsPerPage:numberOfRecords, currentPage: currentPage, totalItems:totalResults} let i = index;"
                  class="hover:bg-gray-950/5 dark:hover:bg-white/10">

                  <td
                    class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap">
                    {{i+1}}
                  </td>
                  <td
                    *ngIf="(tripStatus !== 'onway' && tripStatus !== 'arrived' && tripStatus !== 'in_progress')  && permissionService.hasPermission([userPermission.MANAGE_TRIP]) "
                    class="relative px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    <!-- Selected row marker, only show when row is selected. -->
                    <div class="absolute inset-y-0 left-0 w-0.5 bg-main-primary"
                      [ngClass]="{'hidden': !trip.isSelected}">
                    </div>
                    <input (click)="onSelectTrip(trip)" type="checkbox" [(ngModel)]="trip.isSelected"
                      *ngIf="permissionService.hasPermission([userPermission.MANAGE_TRIP])" type="checkbox" />
                  </td>
                  <!-- actions -->
                  <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    <div class="flex">
                      <button [appToolTip]="'Detail'" (click)="opendetailModal(trip)"
                        class="hover:text-zinc-950 dark:hover:text-white text-zinc-500 dark:text-zinc-400">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                          stroke="currentColor" class="w-5 h-5">
                          <path stroke-linecap="round" stroke-linejoin="round"
                            d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z" />
                          <path stroke-linecap="round" stroke-linejoin="round"
                            d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
                        </svg>
                      </button>

                      <div class="mx-2 w-px bg-zinc-950/10 dark:bg-white/10"></div>
                      <button [appToolTip]="'Notes'" (click)="openNotesModal(trip)"
                        class="hover:text-zinc-950 dark:hover:text-white text-zinc-500 dark:text-zinc-400">
                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24"
                          class="h-5 w-5">
                          <path fill="currentColor"
                            d="M7.154 13.539q.31 0 .54-.23q.229-.23.229-.54t-.23-.54t-.54-.229t-.538.23t-.23.54q0 .309.23.539t.539.23m0-2.77q.31 0 .54-.23q.229-.23.229-.539t-.23-.54t-.54-.23t-.538.23t-.23.54t.23.54t.539.23m0-2.77q.31 0 .54-.23t.229-.54t-.23-.539t-.54-.23t-.538.23t-.23.54t.23.54t.539.229m3.077 5.27H14.5v-1h-4.27zm0-2.77H17.5v-1h-7.27zm0-2.77H17.5v-1h-7.27zM3 20.078V4.616q0-.691.463-1.153T4.615 3h14.77q.69 0 1.152.463T21 4.616v10.769q0 .69-.463 1.153T19.385 17H6.077zM5.65 16h13.735q.23 0 .423-.192t.192-.423V4.615q0-.23-.192-.423T19.385 4H4.615q-.23 0-.423.192T4 4.615v13.03zM4 16V4z" />
                        </svg>
                      </button>
                      <div class="mx-2 w-px bg-zinc-950/10 dark:bg-white/10"></div>
                      <div class="inline-flex relative"
                        *ngIf="permissionService.hasPermission([userPermission.MANAGE_TRIP])">
                        <!-- *ngIf="!assign.isJClone" -->
                        <a [appToolTip]="'More Actions'" *ngIf="!trip.isSelected" href="javascript:void(0)" (click)="showActionButtons(i)"
                          class="hover:text-zinc-950 dark:hover:text-white text-zinc-500 dark:text-zinc-400">
                          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                            stroke="currentColor" class="w-5 h-5">
                            <path stroke-linecap="round" stroke-linejoin="round"
                              d="M12 6.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 12.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 18.75a.75.75 0 110-1.5.75.75 0 010 1.5z" />
                          </svg>
                        </a>
                        <div (outsideClick)="closeActionMenu($event)" outside-click
                          *ngIf="selectedDropdownIndex === i && toggleActionButtons"
                          class="absolute left-4 z-20 my-4 w-64 origin-top-left rounded-md bg-white dark:bg-zinc-900 shadow-lg border border-zinc-950/10 hover:border-zinc-950/20 dark:border-white/10 dark:hover:border-white/20 focus:outline-none"
                          role="menu" aria-orientation="vertical" aria-labelledby="menu-button" tabindex="-1">
                          <!-- (addAdditionalNote)="addAdditionalNote(assign, i)" -->
                          <app-trip-action-dropdown class="divide-y divide-zinc-950/10 dark:divide-white/10"
                            [trip]="trip" (edit)="editTrip($event)"
                            (detail)="opendetailModal($event)" (raiseTicket)="raiseTicket($event)" (cancel)="cancelSignleTrip($event)"
                            (notes)="openNotesModal($event)"
                            (tripTrails)="openTripTrails($event)"
                            (cancelPendingTrip)="openPendingCancelModal($event)"
                            (reofferPendingTrip)="reOfferTrips($event)"
                            >
                          </app-trip-action-dropdown>
                        </div>
                      </div>
                    </div>
                  </td>
                  
                  <!-- Stamps -->
                  <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap">
                  <div class="flex items-center gap-1">
                      <!-- isReady -->
                      <span *ngIf="trip?.flags?.isReady" class="badge-success my-1"> Ready </span>
                      <!-- isVip -->
                      <span *ngIf="trip?.flags?.isVip"
                        class="inline-flex items-center gap-x-1.5 rounded-md bg-[#D0AA00]/10 px-1.5 py-0.5 text-sm/5 font-medium text-[#D0AA00] sm:text-xs/5 forced-colors:outline">
                        VIP </span>
                      <!-- notAnswer -->
                      <span *ngIf="trip?.flags?.isUnanswered"
                        class="inline-flex items-center gap-x-1.5 rounded-md bg-[#FF8080]/10 px-1.5 py-0.5 text-sm/5 font-medium text-[#FF8080] sm:text-xs/5 forced-colors:outline">
                        No Answer </span>
                      <!-- isInvalidNumber -->
                      <span *ngIf="trip?.flags?.isInvalidNumber"
                        class="inline-flex items-center gap-x-1.5 rounded-md bg-[#B3BFFF]/10 px-1.5 py-0.5 text-sm/5 font-medium text-[#B3BFFF] sm:text-xs/5 forced-colors:outline">
                        Invalid Number </span>
                      <!-- isConfirmed -->
                      <span *ngIf="trip?.flags?.isConfirmed"
                        class="inline-flex items-center gap-x-1.5 rounded-md bg-[#FEA405]/10 px-1.5 py-0.5 text-sm/5 font-medium text-[#FEA405] sm:text-xs/5 forced-colors:outline">
                        Confirmed </span>
                 
                     
                  
                      <!-- isMethadone -->
                      <span *ngIf="trip?.flags?.isMethadone"
                        class="inline-flex items-center gap-x-1.5 rounded-md bg-[#27B107]/10 px-1.5 py-0.5 text-sm/5 font-medium text-[#27B107] sm:text-xs/5 forced-colors:outline">
                        Methadone </span>
                 
                      <!-- isEstimation -->
                      <span *ngIf="trip?.flags?.isEstimation"
                        class="inline-flex items-center gap-x-1.5 rounded-md bg-[#27B107]/10 px-1.5 py-0.5 text-sm/5 font-medium text-[#27B107] sm:text-xs/5 forced-colors:outline">
                        Estimation </span>
                        <ng-container *ngIf="trip?.status == 'cancelled'">
                        <span *ngIf="trip.flags.isBillable"
                        class="inline-flex items-center gap-x-1.5 rounded-md bg-[#FEA405]/10 px-1.5 py-0.5 text-sm/5 font-medium text-[#FEA405] sm:text-xs/5 forced-colors:outline">
                        Billable </span>
                           <!-- noshow -->
                      <span *ngIf="trip.flags.isNoShow"
                        class="inline-flex items-center gap-x-1.5 rounded-md bg-[#FF8080]/10 px-1.5 py-0.5 text-sm/5 font-medium text-[#FF8080] sm:text-xs/5 forced-colors:outline">
                        No Show </span>
                 </ng-container>
                        <!-- isWillCallActivated -->
                      <span *ngIf="trip?.flags?.isWillCallActivated"
                        class="inline-flex items-center gap-x-1.5 rounded-md bg-[#27B107]/10 px-1.5 py-0.5 text-sm/5 font-medium text-[#27B107] sm:text-xs/5 forced-colors:outline">
                        WillCall Activated 
                      </span>
                    </div>
                  </td>

                  <!-- Service Areas -->
                  <td
                    class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap">
                    <span *ngIf="preServiceAreas && preServiceAreas[trip.serviceArea]">
                      {{preServiceAreas[trip.serviceArea].title ? (preServiceAreas[trip.serviceArea].title | titlecase)
                      :
                      'N/A'}}
                    </span>
                  </td>
                  <!-- Reference -->
                  <td
                    class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap">
                    <span>
                      {{trip.reference || 'N/A'}}-{{trip.suffix}}
                    </span>
                  </td>
                  <td
                    class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap">
                    <span>
                      {{trip.association || 'N/A'}}
                    </span>
                  </td>
                  <!-- Company -->
                  <td *ngIf="selectedStatus !== 'scheduled'"
                    class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap">
                    <div class="flex flex-col gap-0 leading-tight">
                      <span *ngIf="preCompanies && preCompanies[trip.company]; else elseBlock">
                        {{ (preCompanies[trip.company].name | titlecase) || 'N/A' }}
                      </span>
                      <span class="text-[12px]" *ngIf="trip.company && preCompanies[trip.company] && preCompanies[trip.company].timeZone">
                        ({{ preCompanies[trip.company].timeZone }})
                      </span>
                    </div>
                  </td>
                  <!-- driver -->
                  <td *ngIf="selectedStatus !== 'scheduled' "
                    class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap">
                    <span *ngIf="trip.driver;else elseBlock">
                      {{(trip.driver?.displayName | titlecase )|| 'N/A'}}
                    </span>
                  </td>
                  <!-- member -->
                  <td
                    class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap">
                    <span>
                      {{(trip?.member?.displayName | titlecase) || ''}}
                    </span>
                  </td>
                  <!-- phoneNumber -->
                  <td
                    class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap"
                    phoneNumberFormat [phoneNumber]="trip?.member?.contactNumber">
                    {{ trip?.member?.contactNumber || 'N/A'}}
                  </td>
                  <!-- pickuptime -->
                  <td
                    class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap">
                    <div class="flex flex-col gap-0 leading-tight">
                      <span>{{(trip?.pickup?.time | date: 'MM/DD/YYYY HHmm') || 'N/A'}}</span>
                    </div>
                  </td>
                  <!-- DO time -->
                  <td
                    class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap">
                    <div class="flex flex-col gap-0 leading-tight">
                      <span>{{(trip?.destination?.time | date: 'MM/DD/YYYY HHmm') || 'N/A'}}</span>
                    </div>
                  </td>
                  <!-- pickup address -->
                  <td
                    class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap">
                    {{trip?.pickup?.address?.name || 'N/A'}}</td>
                  <!-- destination address -->
                  <td
                    class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap">
                    {{trip?.destination?.address?.name || 'N/A'}}</td>
                  <!-- miles -->
                  <td
                    class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap">
                      {{ trip.miles ? (trip.miles | number:'1.2-2') + ' mi' : 'N/A' }}
                  </td>
                   <!-- special Fare  -->
                  <td
                    class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap">
                      ${{ trip?.preSpecialRate  || 0}}
                  </td>
                  <!-- spaceType -->
                  <td
                    class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap">
                    <span *ngIf="preSpacetypes && preSpacetypes[trip.spaceType];else elseBlock">
                      {{(preSpacetypes[trip.spaceType].title | uppercase) || 'N/A'}}
                    </span>
                  </td>
                  <!-- appointmentType -->
                  <td
                    class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap">
                    <span *ngIf="preAppointmentType && preAppointmentType[trip.appointmentType]; else elseBlock">
                      {{(preAppointmentType[trip.appointmentType].title | titlecase) || 'N/A'}}
                    </span>
                  </td>
                  <td
                    class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap">
                    <span class="truncate">
                      {{trip.standingorder ? 'Yes'  : ''}}
                    </span> 
                  </td>
                  <!-- createdAt -->
                  <td
                    class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap">
                    {{(trip.createdAt | date: 'MM/DD/YYYY HHmm') || 'N/A'}}</td>
                  <td *ngIf="selectedStatus !== 'pending'"
                    class=" px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap">
                    <div [ngClass]="{
                                          'badge-danger': trip?.status === 'cancelled' || trip?.status === 'reroute',
                                          'badge-success': trip?.status !== 'cancelled' && trip?.status !== 'reroute'
                                        }">
                      {{(trip.status | titlecase) || 'N/A' }}
                    </div>
                  </td>
                  <td *ngIf="selectedStatus === 'all' || selectedStatus === 'pending'"
                    class=" px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap">
                    <div [ngClass]="{'badge-danger': trip?.pendingStatus === 'cancelled' || trip?.pendingStatus === 'rejected',
                                          'badge-success': trip?.pendingStatus !== 'cancelled' && trip?.pendingStatus !== 'reroute'
                                        }">
                      {{(trip.pendingStatus | titlecase) || 'N/A' }}
                    </div>
                  </td>
                    <!-- change reason -->
                   <td *ngIf="selectedStatus === 'all' || selectedStatus === 'pending' || selectedStatus === 'reroute' || selectedStatus === 'cancelled' "
                    class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 ">
                   <div class="w-72 line-clamp-2">
                     {{(trip.changeReasonNotes) || 'N/A'}}
                    </div>
                  </td> 
                  <!-- generalNotes -->
                  <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 ">
                    <div class="w-72 line-clamp-2">
                      {{(trip.generalNotes) || 'N/A'}}
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <ng-template #elseBlock>N/A</ng-template>
          </div>
        </div>
      </div>
    </div>

    <div class="flex justify-end">
      <pagination-controls (pageChange)="onPageChange($event)" class="pagination-controls"></pagination-controls>
    </div>

  </div>


</section>


<app-trip-detail-modal *ngIf="tripId" [tripId]="tripId" (closeModal)="tripId = null"></app-trip-detail-modal>
<app-cancel-modal *ngIf="cancelTripObj" [trip]="cancelTripObj" (cancelTripData)="onCancelTrip($event)"
  (closeModal)="cancelTripObj = null"></app-cancel-modal>
<app-multi-cancel-modal *ngIf="isMultiCancelModal" [trips]="singleTrip ? singleTrip : selectedTrips"
  [preServiceAreas]="preServiceAreas" (cancelTripData)="onCancelTrip($event)"
  (closeModal)="closeMultiCancelModal()"></app-multi-cancel-modal>
<app-notes-modal *ngIf="memberNotesObj" [notes]="memberNotesObj" (closeModal)="memberNotesObj = null"></app-notes-modal>
<app-trips-trails-modal *ngIf="tripTrailId" [tripId]="tripTrailId" (closeModal)="tripTrailId = null"></app-trips-trails-modal>
<app-pending-cancel-modal *ngIf="pendingTripCancelModalObj" 
[data]="pendingTripCancelModalObj"
(closeModal)="onClosePendingCancelModal($event)"
>
</app-pending-cancel-modal>